/* tslint:disable */
import {
  OrderItem,
  Order
} from '../index';

declare var Object: any;
export interface AgentCommissionInterface {
  "reference": string;
  "source": number;
  "partnerId": string;
  "orderItemId"?: number;
  "orderId"?: string;
  "agentType"?: string;
  "dateCreated": Date;
  "unitCommission": number;
  "commissionUnit": string;
  "subTotal": number;
  "unitTax": number;
  "totalTax": number;
  "unitVat": number;
  "totalVat": number;
  "amount": number;
  "status": number;
  "id"?: number;
  orderItem?: OrderItem;
  order?: Order;
}

export class AgentCommission implements AgentCommissionInterface {
  "reference": string;
  "source": number;
  "partnerId": string;
  "orderItemId": number;
  "orderId": string;
  "agentType": string;
  "dateCreated": Date;
  "unitCommission": number;
  "commissionUnit": string;
  "subTotal": number;
  "unitTax": number;
  "totalTax": number;
  "unitVat": number;
  "totalVat": number;
  "amount": number;
  "status": number;
  "id": number;
  orderItem: OrderItem;
  order: Order;
  constructor(data?: AgentCommissionInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `AgentCommission`.
   */
  public static getModelName() {
    return "AgentCommission";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of AgentCommission for dynamic purposes.
  **/
  public static factory(data: AgentCommissionInterface): AgentCommission{
    return new AgentCommission(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'AgentCommission',
      plural: 'AgentCommissions',
      path: 'AgentCommissions',
      idName: 'id',
      properties: {
        "reference": {
          name: 'reference',
          type: 'string'
        },
        "source": {
          name: 'source',
          type: 'number',
          default: 0
        },
        "partnerId": {
          name: 'partnerId',
          type: 'string'
        },
        "orderItemId": {
          name: 'orderItemId',
          type: 'number'
        },
        "orderId": {
          name: 'orderId',
          type: 'string'
        },
        "agentType": {
          name: 'agentType',
          type: 'string'
        },
        "dateCreated": {
          name: 'dateCreated',
          type: 'Date'
        },
        "unitCommission": {
          name: 'unitCommission',
          type: 'number',
          default: 0
        },
        "commissionUnit": {
          name: 'commissionUnit',
          type: 'string',
          default: 'P'
        },
        "subTotal": {
          name: 'subTotal',
          type: 'number',
          default: 0
        },
        "unitTax": {
          name: 'unitTax',
          type: 'number',
          default: 0
        },
        "totalTax": {
          name: 'totalTax',
          type: 'number',
          default: 0
        },
        "unitVat": {
          name: 'unitVat',
          type: 'number',
          default: 0
        },
        "totalVat": {
          name: 'totalVat',
          type: 'number',
          default: 0
        },
        "amount": {
          name: 'amount',
          type: 'number',
          default: 0
        },
        "status": {
          name: 'status',
          type: 'number',
          default: 0
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        orderItem: {
          name: 'orderItem',
          type: 'OrderItem',
          model: 'OrderItem',
          relationType: 'belongsTo',
                  keyFrom: 'orderItemId',
          keyTo: 'id'
        },
        order: {
          name: 'order',
          type: 'Order',
          model: 'Order',
          relationType: 'belongsTo',
                  keyFrom: 'orderId',
          keyTo: 'id'
        },
      }
    }
  }
}
